/* Copy To Clipboard function with fallback for older browsers */
import copy from 'copy-to-clipboard'

export function copyToClipboard(text: string) {
  if (Boolean(navigator.clipboard?.writeText)) {
    navigator.clipboard?.writeText?.(text)
  } else {
    copy(text, {
      format: 'text/plain'
    })
  }

  return
}
